/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_More_OptionsInputs */

const en_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More Options`)
};

const fr_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus d'options`)
};

const de_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Optionen`)
};

const it_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altre opzioni`)
};

const ru_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные варианты`)
};

const es_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más opciones`)
};

const zh_cn2_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多选项`)
};

const ja_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他のオプション`)
};

const hi_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक विकल्प`)
};

const pt_pt2_transcript_export_more_options = /** @type {(inputs: Transcript_Export_More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais opções`)
};

/**
* | output |
* | --- |
* | "More Options" |
*
* @param {Transcript_Export_More_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_more_options = /** @type {((inputs?: Transcript_Export_More_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_More_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_more_options(inputs)
	if (locale === "de") return de_transcript_export_more_options(inputs)
	if (locale === "it") return it_transcript_export_more_options(inputs)
	if (locale === "ru") return ru_transcript_export_more_options(inputs)
	if (locale === "es") return es_transcript_export_more_options(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_more_options(inputs)
	if (locale === "ja") return ja_transcript_export_more_options(inputs)
	if (locale === "hi") return hi_transcript_export_more_options(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_more_options(inputs)
	return en_transcript_export_more_options(inputs)
});